import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {withRouter} from 'react-router';
import propTypes from 'prop-types';
import * as Actions from '../actions';
import lang from '../constants/Languages.js';

//import components
import AboutPage from '../components/characteristics/AboutPage.js';
import LoadingIndicator from '../components/LoadingIndicator.js';
import Error505Page from '../components/Error505Page.js';
import ItemBreadcrumbs from '../components/items/ItemBreadcrumbs.js';

import withTitle from '../scripts/WithTitle.js';

class CharacterAbout extends Component {
    componentDidMount() {
        const { actions, clang, location } = this.props;
        const type = location.pathname.split('/')[1];

        actions.getCharacterAbout(type, clang);
    };

    componentDidUpdate(prevProps, prevState) {
        const { actions, clang, location } = this.props;
        const type = location.pathname.split('/')[1];

        if (clang !== prevProps.clang || location.pathname !== prevProps.location.pathname) {
            actions.getCharacterAbout(type, clang);
        }
    };

    render() {
        const { isLoadingError, isLoading, aboutData, clang, location } = this.props;
        const type = location.pathname.split('/')[1];

        const breadcrumbsList = [{label: 'home'}, {label: type, link: `/${type}`}];
        const typeClass = type === 'records' ? 'records' : '';

        return (
            <section className={`characters character-about ${typeClass}`}>
                <ItemBreadcrumbs list={breadcrumbsList} currentPage={lang[clang].characteristics[type]}/>

                {isLoadingError &&
                    <div className="characters__container">
                        <Error505Page />
                    </div>}

                {!isLoadingError &&
                    ((isLoading &&
                        <div className="characters__container">
                            <LoadingIndicator/>
                        </div>) ||
                    (!isLoading &&
                        <div className={`characters__content ${typeClass}`}>
                            <AboutPage data={aboutData} type={type}/>
                        </div>))}
            </section>
        );
    };
};

CharacterAbout.propTypes = {
    actions: propTypes.object.isRequired,
    aboutData: propTypes.shape({
    }),
    isLoading: propTypes.bool.isRequired,
    isLoadingError: propTypes.bool.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
    aboutData: state.characteristics.aboutData,
    isLoading: state.characteristics.isFetching,
    isLoadingError: state.characteristics.isLoadingError
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});


const enhance = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withTitle,
);

export default enhance(CharacterAbout);



// WEBPACK FOOTER //
// ./src/containers/CharacterAbout.js